import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ReceiptDetailsComponent } from 'src/app/Sets/receipt-details/receipt-details.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { Customer } from 'src/model/customer.model';
import { Profile } from 'src/model/profile.model';

@Component({
    selector: 'app-expense-simpan',
    templateUrl: './expense-simpan.component.html',
    styleUrls: ['./expense-simpan.component.scss'],
    standalone: false
})
export class ExpenseSimpanComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  @Input() totalReserveAmount: number;
  @Input() selectedProfileID: number;
  @Input() viewCustomer: Customer;
  @Input() selectedProfile: Profile;

  withdrawAmount: number;
  selectedAccountId: number;
  companyBankAccountList: Account[] = [];
  cashAccountList: Account[] = [];

  paymentDate: Date = new Date();
  disabledSubmit = false;
  confirmationIC: string;
  confirmationUsername: string;
  remark: string;

  addSimpanExpenseSetId: number;

  ngOnInit(): void {
    const companyId = Number(sessionStorage.getItem('companyId'));
    this.getAllAccountsOfCompany(companyId);
  }

  checkSimpanLeftEnough() {
    if (this.calculateReserveLeft() < 0)
      return false;
    else
      return true;
  }

  private getAllAccountsOfCompany(companyId: number) {
    const loggedInUsername = sessionStorage.getItem("username");
    const xhttp = this.restapi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const account = new Account(json.id, json.number, json.name, json.holderName, json.balance, json.companyId, json.username);

          if (account.Username == undefined)
            this.companyBankAccountList.push(account);
          else if (account.Username == loggedInUsername)
            this.cashAccountList.push(account);
        });
      }
    };
  }

  checkError() {
    let error = false;
    if (this.withdrawAmount == undefined) {
      this.sharedService.openAlert("Please fill in the return amount", ALERT_TYPE.DANGER);
      error = true;
    }
    else if (this.withdrawAmount > this.totalReserveAmount) {
      this.sharedService.openAlert("Return amount cannot be more than total simpan amount", ALERT_TYPE.DANGER);
      error = true;
    }

    if (this.confirmationIC == undefined || this.confirmationIC != this.viewCustomer.ICNumber) {
      this.sharedService.openAlert("Please fill in correct IC Number", ALERT_TYPE.DANGER);
      error = true;
    }

    const username = sessionStorage.getItem("username");
    if (this.confirmationUsername == undefined || this.confirmationUsername != username) {
      this.sharedService.openAlert("Please fill in correct username", ALERT_TYPE.DANGER);
      error = true;
    }

    if (this.selectedAccountId == undefined) {
      this.sharedService.openAlert("Please select an account", ALERT_TYPE.DANGER);
      error = true;
    }

    if (this.remark == undefined) {
      this.sharedService.openAlert("Please fill in remark", ALERT_TYPE.DANGER);
      error = true;
    }

    return error;
  }

  submit() {
    if (this.checkError() == false)
      this.expenseReserve();
  }

  expenseReserve() {
    this.disabledSubmit = true;

    const data = {
      "accountId": Number(this.selectedAccountId),
      "dateCreated": this.paymentDate,
      "reserve": -this.withdrawAmount,
      "remark": "Return simpan to customer = " + this.remark
    };

    const xhr = this.restapi.postRequest(this.constructApi.getExpenseReserve(this.selectedProfileID), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;

        if (xhr.status == 200) {
          const json = JSON.parse(xhr.responseText);

          this.activeModal.close();
          const addedSimpanTransactionId = Number(json.id);
          this.addSimpanExpenseSet([addedSimpanTransactionId]);
        }
        else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  addSimpanExpenseSet(idsToAdd: number[]) {
    this.disabledSubmit = true;

    const companyId = Number(sessionStorage.getItem("companyId"))
    const data = {
      "transactionIds": idsToAdd,
      "remark": "SIMPAN EXPENSE FROM CUSTOMER " + this.viewCustomer.Name,
      "name": "SIMPAN EXPENSE"
    }

    const xhr = this.restapi.postRequest(this.constructApi.getAddNewCompanySet(companyId), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;

        if (xhr.status == 200) {
          var json = JSON.parse(xhr.responseText);
          this.addSimpanExpenseSetId = Number(json.id);
        }
        else {
          var json = JSON.parse(xhr.responseText);
          this.sharedService.openAlert(json.error, ALERT_TYPE.DANGER)
        }

        this.coontinueSimpanExpenseAction();
      }
    }
  }

  coontinueSimpanExpenseAction() {
    if (this.addSimpanExpenseSetId != undefined) {
      const modalRef = this.sharedService.openModal(ReceiptDetailsComponent, "largeModal");
      modalRef.componentInstance.receiptId = Number(this.addSimpanExpenseSetId);
      modalRef.componentInstance.isModal = true;
      modalRef.componentInstance.passEntry.subscribe((entry) => {
        window.location.reload();
      });
    }
    else
      window.location.reload();

    this.sharedService.openAlert("Successfully return simpan!", ALERT_TYPE.SUCCESS);
  }

  isBalanceInsufficient(accountBalance: number) {
    if (accountBalance < this.withdrawAmount)
      return true;
    else
      return false
  }

  calculateReserveLeft() {
    return this.totalReserveAmount - this.withdrawAmount;
  }

  close() {
    this.activeModal.close();
  }
}
